import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api/v1',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
})

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Get CSRF token from cookie if exists (Laravel Sanctum)
    const token = document.cookie
      .split('; ')
      .find((row) => row.startsWith('XSRF-TOKEN='))
      ?.split('=')[1]

    if (token) {
      config.headers['X-XSRF-TOKEN'] = decodeURIComponent(token)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 Unauthorized
    if (error.response?.status === 401) {
      // Redirect to login if not already there
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    }

    // Handle 419 CSRF token mismatch
    if (error.response?.status === 419) {
      // Refresh the page to get new CSRF token
      window.location.reload()
    }

    // Handle 403 Forbidden
    if (error.response?.status === 403) {
      console.error('Access forbidden:', error.response.data?.message)
    }

    // Handle 422 Validation errors
    if (error.response?.status === 422) {
      // Validation errors are handled by the calling code
    }

    // Handle 500 Server errors
    if (error.response?.status >= 500) {
      console.error('Server error:', error.response.data?.message)
    }

    return Promise.reject(error)
  }
)

export default api

// Helper to get CSRF cookie before making requests (Laravel Sanctum)
export async function getCsrfCookie() {
  await axios.get('/sanctum/csrf-cookie', {
    baseURL: import.meta.env.VITE_APP_URL || '',
    withCredentials: true,
  })
}
